import { createFileRoute, redirect } from '@tanstack/react-router';

import { landsOnDocs } from '@/features/docs';
import { HomePage } from '@/features/home';

export const Route = createFileRoute('/_authed/_active/org/')({
  staticData: { crumb: 'common:nav.home', tours: ['home.org', 'welcome'] },
  beforeLoad: ({ context }) => {
    if (landsOnDocs(context.me)) throw redirect({ to: '/docs' });
  },
  component: HomePage,
});
